import { FetchFn } from '@wix/thunderbolt-symbols'
import { MetricsReporter } from '@wix/thunderbolt-becky-types'

export type BuildSvgUrl = (mediaRootUrl: string, svgId: string) => string

export const fetchShapes = async (
	shapeIds: Array<string>,
	fetchFn: FetchFn,
	mediaRootUrl: string,
	buildSvgUrl: BuildSvgUrl,
	metricsReporter: MetricsReporter
): Promise<Record<string, string>> => {
	const shapesArray = await Promise.all(
		(shapeIds ?? []).map(async (shapeId: string) => {
			const shapeUrl = buildSvgUrl(mediaRootUrl, shapeId)
			const fallbackSvg = `<svg data-svg-id="fallback-${shapeId}" />`

			const shapeContent = await fetchFn(shapeUrl)
				.then((resp: Response) => (resp.ok ? resp.text() : fallbackSvg))
				.catch((e) => {
					metricsReporter.reportError(e)
					return fallbackSvg
				})
			return { id: shapeId, content: shapeContent }
		})
	)

	return shapesArray.reduce((acc: Record<string, string>, { id, content }: { id: string; content: string }) => {
		acc[id] = content
		return acc
	}, {} as Record<string, string>)
}
